import React from 'react'
import { Fade } from "@material-ui/core";

const TicketSelectorTabPanel = ({ id, activeTabId, children }) => {
  return (
    <Fade in={activeTabId === id}>
      <div
        className={`ticket-selector__tabpanel ${activeTabId !== id ? "ticket-selector__tabpanel--hidden" : ""}`}
        role='tabpanel'
        tabIndex='0'
        aria-labelledby={`${id}-tab`}
      >
        {children}
      </div>
    </Fade>
  );
}

export default TicketSelectorTabPanel